import AbstractController from '../../../../../vendors/services/abstractController';
import ContribuicaoService from '../../../../services/contribuicao.service';
import {useState} from 'react';

export default class CienciaEventoController extends AbstractController {

  private contribuicaoService: ContribuicaoService;
  public lista: any;
  public setLista: any;


  constructor() {
    super();
    this.contribuicaoService = new ContribuicaoService();
    [this.lista, this.setLista] = useState([]);
  }

  init() {
    super.init();
    this.obterDados();
  }

  obterDados() {
    this.start();
    this.contribuicaoService.getCienciaEvento().then((res: any) => {
      this.stop();
      this.setLista(res.result);
    }).catch((err) => this.stop());
  }


}
